angular.module('zc.projects')

.directive 'campaignTemplateSetting', ->
  restrict: 'E'
  scope:
    campaign: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_template_setting.html'
  link: (scope, element, attrs) ->
    scope.viewOptions =
      details: false



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_template_setting.coffee